import { ReactNode, useEffect } from 'react'
import { CLAVE_AVISO_SESION, useAuthStore } from '../stores/authStore'
import { RolApp } from '../types/auth'

/**
 * Arranque y sincronización de la sesión.
 *
 * El estado vive en `stores/authStore` (lo necesita también el cliente HTTP, fuera
 * de React); este proveedor se encarga de los efectos: preguntar por la sesión al
 * montar la app y volver a preguntar cuando otra pestaña entra o sale.
 */
export function AuthProvider({ children }: { children: ReactNode }) {
  const verificar = useAuthStore((s) => s.verificar)

  useEffect(() => {
    verificar()
    const alCambiarEnOtraPestana = (e: StorageEvent) => {
      if (e.key === CLAVE_AVISO_SESION) verificar()
    }
    window.addEventListener('storage', alCambiarEnOtraPestana)
    return () => window.removeEventListener('storage', alCambiarEnOtraPestana)
  }, [verificar])

  return <>{children}</>
}

/**
 * Atajo para los componentes: usuario, estado y acciones de sesión. `puede(...roles)` dice
 * si la cuenta tiene alguno de esos roles: para mostrar u ocultar lo que no podría usar
 * (la API igual lo rechaza).
 */
export function useAuth() {
  const user = useAuthStore((s) => s.user)
  const estado = useAuthStore((s) => s.estado)
  const error = useAuthStore((s) => s.error)
  const login = useAuthStore((s) => s.login)
  const logout = useAuthStore((s) => s.logout)
  const entrar = useAuthStore((s) => s.entrar)
  const puede = (...roles: RolApp[]) => roles.some((r) => user?.roles?.includes(r))
  return { user, estado, error, login, logout, entrar, puede, conSesion: estado === 'con-sesion' }
}
